module.exports = __webpack_public_path__ + "static/bg-header-faq-3271e975fffa42c8c0374a9fc0455986.jpg";